export interface Theme {
  id: string;
  nom: string;
  primary: string;
  primaryDark: string;
  primaryLight: string;
  bgApp: string;
}

export const THEMES: Theme[] = [
  { id: 'orange',  nom: 'Orange (défaut)', primary: '#C2410C', primaryDark: '#9A3412', primaryLight: '#FEF3EE', bgApp: '#F1EFE8' },
  { id: 'bleu',    nom: 'Bleu océan',      primary: '#1D4ED8', primaryDark: '#1E40AF', primaryLight: '#EFF6FF', bgApp: '#F0F4FF' },
  { id: 'vert',    nom: 'Vert nature',     primary: '#15803D', primaryDark: '#166534', primaryLight: '#F0FDF4', bgApp: '#F0F7F2' },
  { id: 'violet',  nom: 'Violet royal',    primary: '#7C3AED', primaryDark: '#6D28D9', primaryLight: '#F5F3FF', bgApp: '#F4F0FF' },
  { id: 'ardoise', nom: 'Gris ardoise',    primary: '#475569', primaryDark: '#334155', primaryLight: '#F8FAFC', bgApp: '#F4F6F8' },
];

export const themeService = {
  appliquer(theme: Theme) {
    const root = document.documentElement;
    root.style.setProperty('--primary', theme.primary);
    root.style.setProperty('--primary-dark', theme.primaryDark);
    root.style.setProperty('--primary-light', theme.primaryLight);
    root.style.setProperty('--bg-app', theme.bgApp);
    localStorage.setItem('nexacom_theme', theme.id);
  },
  charger() {
    const id = localStorage.getItem('nexacom_theme') || 'orange';
    const theme = THEMES.find(t => t.id === id) || THEMES[0];
    this.appliquer(theme);
    return theme;
  },
  getThemeActuel(): Theme {
    const id = localStorage.getItem('nexacom_theme') || 'orange';
    return THEMES.find(t => t.id === id) || THEMES[0];
  },
};
